import { configureServices } from './store/configure-services';

import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { Settings } from 'luxon';
import { SnackbarProvider } from 'notistack';
import { BrowserRouter } from 'react-router-dom';
import AppComponent from './app';

import configureLogging from '../config/configure-logging';

import { ErrorBoundary } from '../ui/error/error-boundary';
import theme from '../ui/theme';
import { store } from './store/store';

configureLogging();
configureServices(store.dispatch);

const rootEl = document.getElementById('root');
const baseHref = document.querySelector('base')?.getAttribute('href')?.replace(/\/$/, '');

Settings.defaultZone = 'Europe/Zurich';

createRoot(rootEl).render(
  <BrowserRouter basename={baseHref}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ErrorBoundary>
        <Provider store={store}>
          <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <AppComponent />
          </SnackbarProvider>
        </Provider>
      </ErrorBoundary>
    </ThemeProvider>
  </BrowserRouter>,
);
